
<app-shared-layout>
  <div *ngIf="bin_file==true">
    <h3>Downloading Report.........</h3>
  </div>
  <div class="dashboard-page-section" *ngIf="bin_file==false">
    <div class="container">
      <div class="bank-report-options">
        <div class="field-group vertical-field-group mt-10">
          <label for="jumpToFile">Jump to File:</label>
          <select
            id="jumpToFile"
            title="select"
            aria-label="Jump to File select"
            *ngIf="what_if != ''"
            class="report_select"
            (change)="navBarChange($event.target.value, 'report_1')"
          >
            <option *ngFor="let r of banks" [ngValue]="r" [selected]="r === report">{{r}}</option>
          </select>
          <select
            id="jumpToFile"
            title="select"
            aria-label="Jump to File select"
            *ngIf="instr!='undefined' && what_if != 'true'"
            class="report_select"
            (change)="navBarChange($event.target.value, 'report_1')"
          >
            <option *ngFor="let r of banks" [ngValue]="r" [selected]="r === report">{{r}}</option>
          </select>
          <select
            id="jumpToFile"
            title="select"
            aria-label="Jump to File select"
            *ngIf="instr=='undefined' && what_if != 'true'"
            class="report_select"
            (change)="navBarChange($event.target.value, 'report_1')"
          >
            <option *ngFor="let i of banks" [ngValue]="i" [selected]="i=== report">{{i}}</option>
          </select>
          <div class="bank-report-arrows">
            <a
              title="Previous"
              aria-label="Previous"
              href="javascript:void(0);"
              (click)="navBarPrev('report_1')"
              [attr.tabindex]="index==0 ? -1 : 0"
            >
              <img src="assets/images/arrow_circle_left.svg" alt="Previous" [hidden]="index==0" />
            </a>
            <a
              title="Next"
              aria-label="Next"
              href="javascript:void(0);"
              (click)="navBarNext('report_1')"
              [attr.tabindex]="index==banks.length-1 ? -1 : 0"
            >
              <img src="assets/images/arrow_circle_right.svg" alt="Next" [hidden]="index==banks.length-1" />
            </a>
          </div>
        </div>

        <!-- adding qtrs for student analytics-->
        <div class="field-group vertical-field-group mt-10" *ngIf="role=='Student'">
          <label>Quarters</label>
          <select
            title="select"
            aria-label="select"
            *ngIf="role=='Student'"
            class="report_select"
            (change)="selectQtr($event.target.value.replace('Quarter', 'Quater'))"
          >
            <option value="start">Start</option>
            <option *ngFor="let i of qtrs" [ngValue]="i" [selected]="i== qtr">{{i.replace('Quater', 'Quarter')}}</option>
          </select>
        </div>

        <div
          class="field-group vertical-field-group mt-10 ml-10"
          [hidden]="stud=='student' || start=='undefined' || instr=='undefined' || what_if=='true'"
        >
          <label>Team Select:</label>
          <select
            title="select"
            aria-label="select"
            class="report_select"
            [hidden]="stud=='student' || start=='undefined' || instr=='undefined' || what_if=='true'"
            (change)="navBarChange($event.target.value, 'team_1')"
          >
            <option *ngFor="let t of teams" [ngValue]="t" [selected]="t === team">{{t}}</option>
          </select>
          <div class="bank-report-arrows">
            <a
              href="javascript:void(0);"
            >
              <img
                src="assets/images/arrow_circle_left.svg"
                alt="Previous"
                [hidden]="stud=='student' || t_index==0 || stud=='student' || start=='undefined' || instr=='undefined' || what_if=='true'"
                (click)="navBarPrev('team_1')"
              />
            </a>
            <a href="javascript:void(0);">
              <img
                src="assets/images/arrow_circle_right.svg"
                alt="Next"
                [hidden]="stud=='student' || start=='undefined' || t_index==teams.length-1 || instr=='undefined' || what_if=='true'"
                (click)="navBarNext('team_1')"
              />
            </a>
          </div>
        </div>

        <div class="field-group vertical-field-group mt-20 ml-20 action_plan_dashboard" *ngIf="role=='Student' && what_if != 'true'">
          <a
            href="javascript:void(0)"
            tabindex="0"
            (click)="openPDFReportForStudent()"
            role="button"
            aria-label="Print All PDF"
          >
            Print All PDF
            <img src="/assets/images/document_pdf.svg" alt="" aria-hidden="true" />
          </a>
        </div>

        <div
          class="field-group vertical-field-group mt-20 ml-20 action_plan_dashboard"
          *ngIf="role=='Student' && what_if != 'true' && start!='undefined' "
        >
          <a href="javascript:void(0)" (click)="openExcelReportForStudent()">
            Excel Workbook {{start}}
            <img src="/assets/images/window_new.svg" alt="" aria-hidden="true" />
          </a>
        </div>

        <div *ngIf="role=='Student' && current_category !== 'Presentation'" class="action_plan_dashboard">
          <a
            tabindex="0"
            role="button"
            aria-label="Go to Action Plan Dashboard"
            [routerLink]="['/student/control/decision-status']"
            (click)="deactivateMenu()"
          >
            Action Plan Dashboard
            <img src="/assets/images/menu-simulation-dashboard.svg" alt="" aria-hidden="true" />
          </a>
        </div>

        <div *ngIf="role=='Student' && current_category === 'Presentation'" class="action_plan_dashboard">
          <a
            tabindex="0"
            role="button"
            aria-label="Go to Home"
            [routerLink]="['/student/home']"
            (click)="deactivateMenu()"
          >
          <img src="/assets/images/ABA_Home.svg" alt="" aria-hidden="true" />
          Home
          </a>
        </div>

        <!-- Close button for admin/instructor users only -->
        <div class="field-group vertical-field-group mt-10 ml-20" *ngIf="role !== 'Student'">
          <button
            class="dashboard-user-button close-tab-button"
            (click)="closeTab()"
            title="Close Tab"
            aria-label="Close Tab"
            type="button"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <pre id="pre_content" class="pre_content"></pre>
  <div id="report_content_1" *ngIf="report.endsWith('C95-Economic Charts') == false && report.endsWith('B00-Table of Contents') == false"></div>

  <div class="report_data" *ngIf="report.endsWith('B00-Table of Contents') == true">
    <h1 class="pdf-left pdf-report-title">{{date1}}</h1>
    <p class="pdf-right pdf-report-title">{{date2}} {{community}}</p>
    <table class="bank-reports-table table-reports-main">
      <tbody>
        <tr *ngFor="let bank of banks; let i = index" [hidden]="bank.endsWith('B00-Table of Contents')">
          <td>{{ formatBankName(bank) }} -- Page {{i + 1}}</td>
        </tr>
      </tbody>
    </table>
    <span *ngIf="report.endsWith('B00-Table of Contents') == true" style="float: right; margin-right: 15px;"
      >Page {{index + 1}}</span
    >
  </div>

  <div class="report_data" *ngIf="report.endsWith('C95-Economic Charts') == true">
    <h1 class="pdf-left pdf-report-title">
      C95 -- Economic Charts, as of {{date1}}
    </h1>
    <p class="pdf-right pdf-report-title">{{date2}} {{community}}</p>
    <table>
      <thead></thead>
      <tbody>
        <tr>
          <td><img [src]="svg_graph1 | safeHtml" alt="graph" /></td>
          <td><img [src]="svg_graph2 | safeHtml" alt="graph" /></td>
        </tr>
        <tr>
          <td><img [src]="svg_graph3 | safeHtml" alt="graph" /></td>
          <td><img [src]="svg_graph4 | safeHtml" alt="graph" /></td>
        </tr>
      </tbody>
    </table>
    <span *ngIf="report.endsWith('C95-Economic Charts') == true" style="float: right; margin-right: 15px;"
      >Page {{index + 1}}</span
    >
  </div>
  <!-- </pre> -->
  <div
    class="report_footer"
    *ngIf="report.endsWith('C95-Economic Charts') == false && report.endsWith('B00-Table of Contents') == false"
  >
    {{foooter}}
  </div>
  <span
    class="page"
    *ngIf="report.endsWith('C95-Economic Charts') == false && report.endsWith('B00-Table of Contents') == false"
    >Page {{index + 1}}</span
  >
</app-shared-layout>